export function averageRows(arr, columnName) {
  let total = 0;
  try {
    arr.forEach((row) => {
      total += Number(row[columnName]);
    });
  } catch (error) {
    console.error("Error in averageRows function:", error);
    return 0;
  }
  return total / arr.length || 0;
}
